var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('core-app-bar'),_c('core-app-drawer'),_c('core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }